import { createUseStyles } from 'react-jss';
import {
  backgroundSubtle02,
  body01,
  borderError,
  borderFocus,
  borderSubtle01,
  textTertiary,
} from '../../../theme';

export default createUseStyles(
  {
    root: {
      position: 'relative',
      transition: 'all 0.5s ease-in-out',
    },
    bang: {
      margin: 5,
    },
    errorDiv: {
      minHeight: 24,
      width: '100%',
    },
    errorMsg: {
      display: 'inline-flex',
      alignItems: 'center',
      fontSize: 12,
      lineHeight: '16px',
      fontWeight: 400,
      fontFamily: 'roboto',
      maxWidth: 300,
      padding: [6, 0],
    },
    gray: {},

    label: {
      color: textTertiary,
      position: 'absolute',
      top: '50%',
      left: 0,
      transform: 'translate(20px, -50%)',
      transition: 'top 0.2s,left 0.2s,transform 0.2s,translate 0.2s',
      zIndex: -1,
    },

    labelBorderFocus: {
      color: borderFocus,
      position: 'absolute',
      top: 0,
      left: 0,
      transform: 'translate(0px, -65%)',
      scale: 0.8,
      transition: 'top 0.2s,left 0.2s,transform 0.2s,translate 0.2s',
      backgroundColor: '#fff',
      padding: [2, 6],
      fontWeight: 100,
      zIndex: 2,
    },
    exocadLabelBorderFocus: {
      color: '#473A6D',
      position: 'absolute',
      top: 0,
      left: 0,
      transform: 'translate(0px, -65%)',
      scale: 0.8,
      transition: 'top 0.2s,left 0.2s,transform 0.2s,translate 0.2s',
      backgroundColor: '#fff',
      padding: [2, 6],
      fontWeight: 100,
      zIndex: 2,
    },

    labelBorderBlur: {
      color: textTertiary,
    },

    input: {
      width: '100%',
      boxSizing: 'border-box',
      padding: [14, 16],
      borderRadius: 8,
      border: `1px solid ${borderSubtle01}`,
      backgroundColor: 'transparent',
      outline: 'none',

      '$gray &': {
        backgroundColor: backgroundSubtle02,
      },

      '&:hover': {
        borderColor: borderSubtle01,
      },

      '&:focus-visible': {
        borderColor: borderFocus,
        borderWidth: '2px',
        margin: '-1px',
      },

      '&::placeholder': {
        ...body01,
        color: textTertiary,
      },

      '&:-webkit-autofill, &:-webkit-autofill:hover, &:-webkit-autofill:focus, &:-webkit-autofill:active':
        {
          boxShadow: '0 0 0 30px white inset',
        },
    },
    exocadInput: {
      width: '100%',
      boxSizing: 'border-box',
      padding: [14, 16],
      borderRadius: 8,
      border: `1px solid ${borderSubtle01}`,
      backgroundColor: 'transparent',
      outline: 'none',

      '$gray &': {
        backgroundColor: backgroundSubtle02,
      },

      '&:hover': {
        borderColor: borderSubtle01,
      },

      '&:focus-visible': {
        borderColor: '#473A6D',
        borderWidth: '2px',
        margin: '-1px',
      },

      '&::placeholder': {
        ...body01,
        color: textTertiary,
      },

      '&:-webkit-autofill, &:-webkit-autofill:hover, &:-webkit-autofill:focus, &:-webkit-autofill:active':
        {
          boxShadow: '0 0 0 30px white inset',
        },
    },
    withError: {
      color: `${borderError} !important`,
      '& $input': {
        borderColor: borderError,
      },
    },
  },
  {
    name: 'TextField',
  },
);
